export const defaultColors = {
  primaryColor: "#887952",
  accentColor: "#726545",
};

export const adjustHexBrightnessByPercent = (hexColor: string, percent: number): string => {
  if (!/^#([A-Fa-f0-9]{6})$/.test(hexColor)) {
    console.error("Invalid color format. Please provide a hex color like #RRGGBB.");
    return hexColor;
  }

  const brightnessDelta = Math.round(2.55 * Math.abs(percent));

  let red = parseInt(hexColor.substring(1, 3), 16) + (percent > 0 ? brightnessDelta : -brightnessDelta);
  let green = parseInt(hexColor.substring(3, 5), 16) + (percent > 0 ? brightnessDelta : -brightnessDelta);
  let blue = parseInt(hexColor.substring(5, 7), 16) + (percent > 0 ? brightnessDelta : -brightnessDelta);

  red = Math.min(255, Math.max(0, red));
  green = Math.min(255, Math.max(0, green));
  blue = Math.min(255, Math.max(0, blue));

  return `#${red.toString(16).padStart(2, "0")}${green.toString(16).padStart(2, "0")}${blue.toString(16).padStart(2, "0")}`;
};


export const scaleHexBrightness = (hexColor: string, factor: number): string => {
  if (!/^#([A-Fa-f0-9]{6})$/.test(hexColor)) {
    console.error("Invalid hex color. Use format like #RRGGBB");
    return hexColor;
  }

  const red = parseInt(hexColor.slice(1, 3), 16);
  const green = parseInt(hexColor.slice(3, 5), 16);
  const blue = parseInt(hexColor.slice(5, 7), 16);

  const scaleChannel = (value: number) => Math.max(0, Math.min(255, Math.floor(value * factor)));

  const adjustedRed = scaleChannel(red);
  const adjustedGreen = scaleChannel(green);
  const adjustedBlue = scaleChannel(blue);

  return (
    "#" +
    [adjustedRed, adjustedGreen, adjustedBlue]
      .map((channel) => channel.toString(16).padStart(2, "0"))
      .join("")
  );
};


export const darkenColor = (color: string, percent: number = 15): string => {
  return adjustHexBrightnessByPercent(color, -percent);
};

export const lightenColor = (color: string, percent: number = 20): string => {
  return adjustHexBrightnessByPercent(color, percent);
};

export const getHoverColor = (color: string): string => {
  return darkenColor(color, 10);
};

export const applyCSSVariables = (
  primaryColor: string | null,
  accentColor: string | null
) => {
  primaryColor = primaryColor || defaultColors.primaryColor;
  accentColor = accentColor || defaultColors.accentColor;
  document.documentElement.style.setProperty("--primary-color", primaryColor);
  document.documentElement.style.setProperty("--accent-color", accentColor);

  document.documentElement.style.setProperty("--primary-hover",getHoverColor(primaryColor));
  document.documentElement.style.setProperty("--primary-dark-color",darkenColor(primaryColor, 15));
  document.documentElement.style.setProperty("--primary-light-color",lightenColor(primaryColor, 20));

  document.documentElement.style.setProperty("--accent-hover",scaleHexBrightness(accentColor, 0.95));
  document.documentElement.style.setProperty("--accent-dark-color",scaleHexBrightness(accentColor, 0.666));
  document.documentElement.style.setProperty("--accent-light-color",lightenColor(accentColor, 20));
  document.documentElement.style.setProperty("--accent-border-color",adjustHexBrightnessByPercent(accentColor, 35));
};
